<template>
    <div class="container mt-5">
        <div class="col-xs-12 text-xs-left">
            <h3>{{ $t('YOUR_ACCOUNT_IS_INACTIVE') }}</h3>
            <h4>{{ $t('DEACTIVATION_DATE') }} {{ dateDeactivated }}</h4>
            <h4>{{ $t('TO_USE_BRASTER_YOU_NEED_ACTIVE_ACCOUNT') }}</h4>
            <div class="text-center mt-4 mb-5">
                <button class="app-btn app-btn--big app-btn-primary" @click="showModal = true">
                    {{ $t('ACTIVATE_ACCOUNT') }}
                </button>
            </div>

            <h4>{{ $t('ACTIVE_ACCOUNT_IS') }}</h4>

            <table class="mb-5">
                <tr>
                    <img src="../../../assets/images/icons/ico-ok-green.png" />
                    <td>{{ $t('ACCESS_TO_YOUR_EXAMINATION_RESULTS') }}</td>
                </tr>
                <tr>
                    <img src="../../../assets/images/icons/ico-ok-green.png" />
                    <td>{{ $t('INFORMATION_ABOUT_EXAMINATIONS_TO_USE') }}</td>
                </tr>
                <tr>
                    <img src="../../../assets/images/icons/ico-ok-green.png" />
                    <td>{{ $t('EVERY_MONTH_EXAMINATION_REMINDER') }}</td>
                </tr>
            </table>
        </div>
        <modal v-if="showModal" @close="$router.push({ name: 'logowanie' })" class="unlock-request-modal">
            <survey-step5-q1 :single="true" :unlockRequest="true" @sendUnlockRequest="sendUnlockRequest" />
        </modal>
    </div>
</template>

<script>
import { mapDateToUserTimezone } from './../../../main';
import Modal from './../../modals/_modal.vue';
import SurveyStep5Q1 from './../../modals/main-survey/survey-step5-q1.vue';

export default {
    components: {
        Modal,
        SurveyStep5Q1,
    },
    data() {
        return {
            showModal: false,
            dateDeactivated: this.$route.query.dateDeactivated,
            username: this.$route.query.username,
            password: this.$route.query.password,
        };
    },
    created() {
        if (!this.username || !this.password) {
            this.$router.push({ name: 'logowanie' });
        }
    },
    methods: {
        mapDateToUserTimezone,
        sendUnlockRequest(unlockRequest) {
            this.$http
                .post('/user/public/registration/unlockRequest', {
                    ...unlockRequest,
                    username: this.username,
                    password: this.password,
                })
                .then(() => this.$router.push({ name: 'prosba-wyslana' }))
                .catch(() => this.$router.push({ name: 'logowanie' }));
        },
    },
};
</script>

<style lang="scss" scoped>
h3,
h4 {
    text-align: center;
}

table {
    margin-left: 33%;
    margin-right: auto;
}

td {
    padding: 0 0 8px 5px;
    word-wrap: break-word;
    width: 405px;
}

img {
    padding-right: 5px;
    height: 20px;
}

@media (max-width: 1200px) {
    table {
        margin-left: 29%;
    }
}

@media (max-width: 991px) {
    table {
        margin-left: 25%;
    }
}

@media (max-width: 768px) {
    table {
        margin-left: 20%;
    }
}

@media (max-width: 500px) {
    table {
        margin-left: 13%;
    }
}
</style>



// WEBPACK FOOTER //
// banned-account.vue?4b3a8831